<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M2 7C2 6.44772 2.44772 6 3 6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H3C2.44772 8 2 7.55228 2 7ZM5 11C5 11.5523 5.44772 12 6 12H18C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10H6C5.44772 10 5 10.4477 5 11ZM9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H9ZM11 20C10.4477 20 10 19.5523 10 19C10 18.4477 10.4477 18 11 18H13C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H11Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>

</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>